// extracted by mini-css-extract-plugin
module.exports = {"textArea":"CommentBlock_textArea__0qxO3"};